import {  useInView } from "framer-motion";
import { useRef, useEffect } from "react";
import videoSrc from "../assets/coverpage1.mp4"; 
import videoMobile from "../assets/coverpagee.mp4";  




export default function Hero() {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { threshold: 0.4 });
  // const [animateKey, setAnimateKey] = useState(0);

  useEffect(() => {
    if (isInView) {
      // setAnimateKey((prev) => prev + 1);
    }
  }, [isInView]);

  return (
    <section ref={sectionRef} className="relative w-full min-h-screen overflow-hidden -mt-24">
      {/* Background Image */}
      <video
    className="absolute inset-0 w-full h-full object-cover z-0"
    src={videoSrc}
    autoPlay
    loop
    muted
    playsInline
  />

    {/* Mobile Video Background */}
    <video
        className="block sm:hidden absolute inset-0 w-full h-full object-cover z-0"
        src={videoMobile}
        autoPlay
        loop
        muted
        playsInline
      />

      {/* Hero Text Content */}
      <div className="relative z-10 h-screen flex flex-col justify-center items-center text-white text-center px-4 mt-10">
        
      </div>
    </section>
  );
}
